import type { TOC } from '@ember/component/template-only';
import DocumentCenter from 'tio-employee/components/reimagined/document-center';
import type { DocumentCenterModel } from 'tio-employee/components/reimagined/document-center';

interface Signature {
  Args: { model: DocumentCenterModel };
}

const template: TOC<Signature> = <template>
  <DocumentCenter @model={{@model}} @variant="reimagined" />
</template>;

export default template;
